type Props = {
  isPrev: boolean;
};
const SwiperNav = ({ isPrev = false }: Props): JSX.Element => {
  return (
    <button
      className={`${
        isPrev
          ? '-left-4 review-swiper-button-previous hover:-translate-x-2'
          : 'right-0 review-swiper-button-next hover:translate-x-2'
      } hidden lg:block focus:outline-none duration-200 focus:bg-grey50 absolute transform z-10 h-15 w-15 rounded-full p-3 bg-white top-1/3 lg:-mr-6 shadow-bs80`}
    >
      <img
        width="32"
        height="32"
        alt="Ikon pil åt höger"
        className={`w-8 h-8 ${isPrev ? 'transform rotate-180' : ''}`}
        src="/Images/Icons/Arrows/arrow-right-blue700.svg"
      />
    </button>
  );
};
export default SwiperNav;
